// React
import { ReactElement } from 'react';
// Design System
import Select, { ActionMeta, OnChangeValue } from 'react-select';
import { Flag } from '@utmb/design-system/flag/Flag';
import { PiCategoryLogo } from '@utmb/design-system/pi-category-logo/PiCategoryLogo';
import { Font } from '@utmb/design-system/text/font';
// Styles
import styles from './filters.country.module.scss';
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
import SelectOptionView from '@utmb/types/view/SelectOptionView';

interface ReactSelectFilterOption {
    label: string;
    value: string;
}

export interface ReactSelectFilterProps {
    options: SelectOptionView[];
    selectedOptions: string[];
    handleCheck: (value: string) => void;
    filterType: 'country' | 'category' | 'default';
    placeholder: string;
}

const ReactSelectFilter = (props: ReactSelectFilterProps): ReactElement => {
    const { options, selectedOptions, handleCheck, filterType, placeholder } = props;

    const optionsTab = options.map(({ label, value }: ReactSelectFilterOption) => ({ label, value }));

    let optionsSelectedTab: ReactSelectFilterOption[] = [];
    if (selectedOptions) {
        optionsSelectedTab = optionsTab.filter((optionsTab) => selectedOptions.includes(optionsTab.value));
    }

    const customStyles = {
        indicatorsContainer: (prevStyle: any, state: any) =>
            state.isMulti
                ? {
                      ...prevStyle,
                      display: 'none',
                  }
                : null,
        menu: (provided: any) => ({
            ...provided,
            margin: 0,
            borderRadius: 0,
            paddingTop: 0,
        }),
        control: (provided: any) => ({
            ...provided,
            borderRadius: 0,
            cursor: 'pointer',
        }),
        option: (provided: any) => ({
            ...provided,
            borderBottom: '1px solid #80808059',
            padding: '20px',
            cursor: 'pointer',
        }),
        multiValueRemove: (provided: any) => ({
            ...provided,
            color: 'var(--utmb-color-red)',
            cursor: 'pointer',
        }),
        noOptionsMessage: (provided: any) => ({
            ...provided,
            fontFamily: 'var(--utmb-font-oxanium)',
        }),
        input: (provided: any) => ({
            ...provided,
            fontFamily: 'var(--utmb-font-oxanium)',
        }),
    };

    const handleChange = (selectedOption: OnChangeValue<ReactSelectFilterOption, true>, { action }: ActionMeta<ReactSelectFilterOption>) => {
        switch (action.toString()) {
            case 'select-option':
                optionsSelectedTab.push({ label: selectedOption[selectedOption.length - 1].label, value: selectedOption[selectedOption.length - 1].value });
                handleCheck(selectedOption[selectedOption.length - 1].value);
                break;
            case 'remove-value':
                {
                    optionsSelectedTab.map(({ value }: any) => {
                        handleCheck(value);
                    });
                }
                {
                    selectedOption.map(({ value }: any) => {
                        handleCheck(value);
                    });
                }
                break;
            default:
                break;
        }
    };

    return (
        <Select
            placeholder={<Font.OxaniumRegular mobile="14">{placeholder}</Font.OxaniumRegular>}
            isMulti={true}
            value={optionsSelectedTab}
            options={optionsTab}
            onChange={handleChange}
            styles={customStyles}
            isSearchable={true}
            menuIsOpen={true}
            formatOptionLabel={(option: any) => (
                <div className={styles.item}>
                    {filterType === 'country' && (
                        <div className={styles.flag_wrapper}>
                            <Flag isoCode={option.value} />
                            <Font.OxaniumRegular mobile="14" className={`${styles.filter_label} ${styles.flag_label}`}>
                                {option.label}
                            </Font.OxaniumRegular>
                        </div>
                    )}
                    {filterType === 'category' && (
                        <div className={styles.flag_wrapper}>
                            <PiCategoryLogo height={20} piCategory={option.value as PiCategoryEnum} />
                        </div>
                    )}
                    {filterType === 'default' && (
                        <div className={styles.flag_wrapper}>
                            <Font.OxaniumRegular mobile="14">{option.label}</Font.OxaniumRegular>
                        </div>
                    )}
                </div>
            )}
        />
    );
};

export default ReactSelectFilter;
